import { PRO_VALIDATION_ERROR_TYPES } from '@shared/pro-number-validation';

export const ERROR_MESSAGES = {
  DUPLICATE_PRO_NUMBER: 'Duplicate pro number',
  REQUIRED: 'Required',
  INVALID_PRO_NUMBER: 'Pro number entered is invalid',
  PRO_NUMBER_MIN: 'Pro number is too short',
  PRO_NUMBER_MAX: 'Pro number is too long',
  PRO_NUMBER_LENGTH_MISMATCH: 'Pro number length mismatch',
  INVALID_CHECK_DIGIT: 'Invalid check digit',
  TERMINAL_MISMATCH: 'First 3 numbers in the pro number should match the terminal number'
};

export const getErrorMessage = (error) => {
  if (!error || !error.errorType) return null;

  const { errorType, metaData } = error;

  switch (errorType) {
    case PRO_VALIDATION_ERROR_TYPES.REQUIRED:
      return ERROR_MESSAGES.REQUIRED;
    case PRO_VALIDATION_ERROR_TYPES.INVALID_PRO_NUMBER:
      return ERROR_MESSAGES.INVALID_PRO_NUMBER;
    case PRO_VALIDATION_ERROR_TYPES.PRO_NUMBER_MIN:
      return metaData?.minLength
        ? `Pro number must be min ${metaData.minLength} digits`
        : ERROR_MESSAGES.PRO_NUMBER_MIN;
    case PRO_VALIDATION_ERROR_TYPES.PRO_NUMBER_MAX:
      return metaData?.maxLength
        ? `Pro number cannot be more than ${metaData.maxLength} digits`
        : ERROR_MESSAGES.PRO_NUMBER_MAX;
    case PRO_VALIDATION_ERROR_TYPES.PRO_NUMBER_LENGTH_MISMATCH:
      return metaData?.expectedLength
        ? `Pro number should be ${metaData.expectedLength} digits`
        : ERROR_MESSAGES.PRO_NUMBER_LENGTH_MISMATCH;
    case PRO_VALIDATION_ERROR_TYPES.INVALID_CHECK_DIGIT:
      return ERROR_MESSAGES.INVALID_CHECK_DIGIT;
    case PRO_VALIDATION_ERROR_TYPES.DUPLICATE_NUMBER:
      return ERROR_MESSAGES.DUPLICATE_PRO_NUMBER;
    case PRO_VALIDATION_ERROR_TYPES.TERMINAL_MISMATCH:
      return ERROR_MESSAGES.TERMINAL_MISMATCH;
    default:
      return null;
  }
};
